import styled from 'styled-components'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import { Layout, PrimaryButton, SelectBox } from '../components'
// Mui
import TextField from '@material-ui/core/TextField'
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
// Firebase
import { db, functions, FirebaseTimestamp } from '../firebase'
// images
import HeroImage from '../assets/rzeus/hero.jpg'
import Logo from '../assets/rzeus/logo.png'
import Athletes1 from '../assets/rzeus/athletes1.png'
import Athletes2 from '../assets/rzeus/athletes2.png'
import Underwear1 from '../assets/rzeus/underwear-1.png'
import AntiVirus1 from '../assets/rzeus/anti-virus-1.png'
import AntiVirus2 from '../assets/rzeus/anti-virus-2.png'
import ProjectAthlete from '../assets/rzeus/project-athlete.png'
import Rizin from '../assets/rzeus/rizin.jpg'
import Mask1 from '../assets/rzeus/mask1.png'
import Mask2 from '../assets/rzeus/mask2.png'
import Mask3 from '../assets/rzeus/mask3.png'
import Mask4 from '../assets/rzeus/mask4.png'
import Mask5 from '../assets/rzeus/mask5.png'
import PantsNormal1 from '../assets/rzeus/pants-normal-1.png'
import PantsNormal2 from '../assets/rzeus/pants-normal-2.png'
import PantsNormal3 from '../assets/rzeus/pants-normal-3.png'
import PantsNormal4 from '../assets/rzeus/pants-normal-4.png'
import PantsNormal5 from '../assets/rzeus/pants-normal-5.png'
import PantsShort1 from '../assets/rzeus/pants-short-1.png'
import PantsShort2 from '../assets/rzeus/pants-short-2.png'
import PantsShort3 from '../assets/rzeus/pants-short-3.png'
import PantsShort4 from '../assets/rzeus/pants-short-4.png'
import PantsShort5 from '../assets/rzeus/pants-short-5.png'
import SetNormal1 from '../assets/rzeus/set-normal-1.png'
import SetNormal2 from '../assets/rzeus/set-normal-2.png'
import SetNormal3 from '../assets/rzeus/set-normal-3.png'
import SetNormal4 from '../assets/rzeus/set-normal-4.png'
import SetNormal5 from '../assets/rzeus/set-normal-5.png'
import SetShort1 from '../assets/rzeus/set-short-1.png'
import SetShort2 from '../assets/rzeus/set-short-2.png'
import SetShort3 from '../assets/rzeus/set-short-3.png'
import SetShort4 from '../assets/rzeus/set-short-4.png'
import SetShort5 from '../assets/rzeus/set-short-5.png'
import BackToTop from '../assets/rzeus/btn_backtotop.png'
import PreOrder from '../assets/rzeus/btn_preorder.png'

const productTypeList = [
    {id: 'pants-normal', name: 'ノーマルパンツ（4,950円）', price: 4950},
    {id: 'pants-short', name: 'ショートパンツ（4,950円）', price: 4950},
    {id: 'mask', name: 'マスク（1,980円）', price: 1980},
    {id: 'set-normal', name: 'ノーマル＋マスク（6,600円）', price: 6600},
    {id: 'set-short', name: 'ショート＋マスク（6,600円）', price: 6600},
]

const productList = [
    {id: 'pants-normal-1', name: 'ノーマルタイプ（ブラック＆レッド）', price: 4950},
    {id: 'pants-normal-2', name: 'ノーマルタイプ（ホワイト）', price: 4950},
    {id: 'pants-normal-3', name: 'ノーマルタイプ（イエロー）', price: 4950},
    {id: 'pants-normal-4', name: 'ノーマルタイプ（ブラック）', price: 4950},
    {id: 'pants-normal-5', name: 'ノーマルタイプ（ホワイト＆レッド）', price: 4950},
    {id: 'pants-short-1', name: 'ショートタイプ（ブラック＆レッド）', price: 4950},
    {id: 'pants-short-2', name: 'ショートタイプ（ホワイト）', price: 4950},
    {id: 'pants-short-3', name: 'ショートタイプ（イエロー）', price: 4950},
    {id: 'pants-short-4', name: 'ショートタイプ（ブラック）', price: 4950},
    {id: 'pants-short-5', name: 'ショートタイプ（ホワイト＆レッド）', price: 4950},
    {id: 'mask1', name: 'マスク（ブラック＆レッド）', price: 1980},
    {id: 'mask2', name: 'マスク（ホワイト）', price: 1980},
    {id: 'mask3', name: 'マスク（イエロー）', price: 1980},
    {id: 'mask4', name: 'マスク（ブラック）', price: 1980},
    {id: 'mask5', name: 'マスク（ホワイト＆レッド）', price: 1980},
    {id: 'set-normal-1', name: 'マスク＆パンツセット・ノーマルタイプ（ブラック＆レッド）', price: 6600},
    {id: 'set-normal-2', name: 'マスク＆パンツセット・ノーマルタイプ（ホワイト）', price: 6600},
    {id: 'set-normal-3', name: 'マスク＆パンツセット・ノーマルタイプ（イエロー）', price: 6600},
    {id: 'set-normal-4', name: 'マスク＆パンツセット・ノーマルタイプ（ブラック）', price: 6600},
    {id: 'set-normal-5', name: 'マスク＆パンツセット・ノーマルタイプ（ホワイト＆レッド）', price: 6600},
    {id: 'set-short-1', name: 'マスク＆パンツセット・ショートタイプ（ブラック＆レッド）', price: 6600},
    {id: 'set-short-2', name: 'マスク＆パンツセット・ショートタイプ（ホワイト）', price: 6600},
    {id: 'set-short-3', name: 'マスク＆パンツセット・ショートタイプ（イエロー）', price: 6600},
    {id: 'set-short-4', name: 'マスク＆パンツセット・ショートタイプ（ブラック）', price: 6600},
    {id: 'set-short-5', name: 'マスク＆パンツセット・ショートタイプ（ホワイト＆レッド）', price: 6600},
]

const quantityList = [
    {id: 1, name: '1個'},
    {id: 2, name: '2個'},
    {id: 3, name: '3個'},
    {id: 4, name: '4個'},
    {id: 5, name: '5個'},
    {id: 6, name: '6個'},
    {id: 7, name: '7個'},
    {id: 8, name: '8個'},
    {id: 9, name: '9個'},
    {id: 10, name: '10個'},
]

const dateToString = (date) => {
    return date.getFullYear() + '年' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '月' + 
        ('00' + date.getDate()).slice(-2) + '日'
}

const PreOrdersRef = db.collection('preOrders')

const Rzeus = () => {

    const dispatch = useDispatch()

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [tel, setTel] = useState('')
    const [postalCode, setPostalCode] = useState('')
    const [prefecture, setPrefecture] = useState('')
    const [city, setCity] = useState('')
    const [street, setStreet] = useState('')

    const [productType, setProductType] = useState('')
    const [product, setProduct] = useState('')
    const [size, setSize] = useState('')
    const [quantity, setQuantity] = useState('')

    const amount = productList[product] ? productList[product].price * quantity : 0

    const handleChangeProduct = (event) => {
        setProduct(event.target.value);
    }
    const handleChangeSize = (event) => {
        setSize(event.target.value);
    }

    const complementAddress = () => {
        const { AjaxZip3 } = window
        AjaxZip3.zip2addr( 'postCode', '', 'address1', 'address2', 'address3' )
    }
    const onBlurZipcode = () => {
        setPrefecture(document.getElementById('address1').value)
        setCity(document.getElementById('address2').value)
        setStreet(document.getElementById('address3').value)
    }

    const saveOrder = (productType, product, size, quantity, amount, name, email, tel, postalCode, prefecture, city, street) => {
        if (productType === '') {
            alert('「商品タイプ」が未選択です。')
            return false
        }
        if (product === '') {
            alert('「商品」が未選択です。')
            return false
        }
        if (size === '') {
            alert('「サイズ」が未選択です。')
            return false
        }
        if (quantity === '') {
            alert('「数量」が未選択です。')
            return false
        }
        if (name === '') {
            alert('「お名前」が未入力です')
            return false
        }
        if (email === '') {
            alert('「メールアドレス」が未入力です')
            return false
        }
        if (tel === '') {
            alert('「電話番号」が未入力です')
            return false
        }
        if (postalCode === '') {
            alert('「郵便番号」が未入力です')
            return false
        }
        if (prefecture === '') {
            alert('「都道府県」が未入力です')
            return false
        }
        if (city === '') {
            alert('「市区町村」が未入力です')
            return false
        }
        if (street === '') {
            alert('「番地以降」が未入力です')
            return false
        }
        // email validation
        const regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        if (!regexEmail.test(email)) {
            alert('メールアドレスの形式が不正です。もう1度お試しください。')
            return false
        }
        // 電話番号Validation
        if (tel) {
            const regexTel = /^[0-9]{10,11}$/
            if (!regexTel.test(tel)) {
                alert('電話番号は10桁または11桁の数字で入力してください（ハイフン不要）')
                return false
            }
        }

        if (window.confirm('送信します。よろしいですか？')) {
            // 保存データのセット
            const timestamp = FirebaseTimestamp.now()
            const submitDate = dateToString(timestamp.toDate())
            const newPreOrderId = PreOrdersRef.doc().id
            const data = {
                id: newPreOrderId,
                product, size, quantity, amount, name, email, tel, prefecture, city, street,
                created_at: timestamp
            }
            const mailData = {
                to: email,
                subject: '【T3】ご予約ありがとうございました',
                text: `
${name}様

この度はRZEUSプロダクトをご予約いただきありがとうございます。
下記の内容でご予約を承りました。
--------------------------------------------------
【ご予約日】 ${submitDate}
【ご注文者】${name}
【ご住所】
〒${postalCode}
${prefecture}${city}${street}
【電話番号】${tel}
【Email】${email}

【ご予約商品】
${product}
${size}サイズ
${quantity}個

【ご購入金額】
◇購入合計／ ${amount}円
◇送料　　／ 600円
-------------------------------------------
◆ご請求総額　／ ${amount+600}円
-------------------------------------------


【T3】ニューネックス株式会社
〒153-0042 東京都 目黒区青葉台1-27-3 2F
TEL：03-5544-9770
Email：shop@newnex.net

発売までいましばらくお待ち下さい。
`
            }
            const mailDataAdmin = {
                to: 'shop@newnex.net',
                subject: '【T3】RZEUSのご予約がありました',
                text: `
RZEUSプロダクトのご予約がありました。

--------------------------------------------------
【ご予約日】 ${submitDate}
【ご注文者】${name}
【ご住所】
〒${postalCode}
${prefecture}${city}${street}
【電話番号】${tel}
【Email】${email}

【ご予約商品】
${product}
${size}サイズ
${quantity}個

【ご購入金額】
◇購入合計／ ${amount}円
◇送料　　／ 600円
-------------------------------------------
◆ご請求総額　／ ${amount+600}円
-------------------------------------------
`
            }
            const sendMail = functions.httpsCallable('sendMail')
            // Firestoreに保存
            PreOrdersRef.doc(newPreOrderId).set(data)
                       .then(() => {
                           // メール送信
                           sendMail(mailData)
                           sendMail(mailDataAdmin)
                           // 画面遷移
                           dispatch(push('/brand/rzeus/complete'))
                       })
        } else {
            return false;
        }
    }

    return (
        <Layout alone>

            
            <Hero />

            <Section>
                <H4>肉体美を極めたアスリートによる</H4>
                <FlexWrapper>
                    <H1>究極のアンダーウェア<Bracket>「</Bracket></H1>
                    <div><img src={Logo} alt="rzeus" width={240} /></div>
                    <H1><Bracket>」</Bracket>登場</H1>
                </FlexWrapper>
                <FlexWrapper>
                    <FlexHalf>
                        <Text>つねに健康・睡眠・食に気を遣い、飛躍的なパフォーマンス向上により世界のトップを目指すトップアスリート。限界まで極めた肉体美を持つ選手は美やファッションにもこだわる。</Text>
                        <div className='spacer-25' />
                        <Text>なかでも身体の中心であるパンツの需要性を、リオオリンピック銀メダリスト/総合格闘家 太田忍は語る。</Text>
                        <div className='spacer-25' />
                        <Text>「身体の中心であるアンダーウエアの保護やサポートをするには、おさまりいいことや人間の理想的な温度調整ができるものがいい」」と企画開発に入念に行い、またモチベーション上がるものがいいとデザインにもこだわりました。</Text>
                    </FlexHalf>
                    <FlexHalf>
                        <img src={Athletes1} alt={'rzeus'} style={{width:'100%'}} />
                    </FlexHalf>
                </FlexWrapper>
            </Section>

            <div className='spacer-100' />

            <H2>Underwear</H2>
            <Section>
                <div className='spacer-50' />
                <H3>選ばれる理由</H3>
                <FlexWrapper>
                    <FlexHalf>
                        <FlexWrapper style={{flexDirection: 'row'}}>
                            <Circle>01</Circle>
                            <H4>デザイン性</H4>
                        </FlexWrapper>
                        <div className='spacer-25' />
                        <Text>「どうせ見えないから」と諦めてませんか？女性は一番気にしているのが、男の下着・・・デザイン性ある下着を選ぶ男性は、「モチベーションがあがる。」「ブレないから安心していられる」と下着の重要性に気づいてます。多くのアスリートも新しい下着に履き替えオリンピックを目指します。</Text>
                        
                        <div className='spacer-25' />

                        <FlexWrapper style={{flexDirection: 'row'}}>
                            <Circle>02</Circle>
                            <H4>履き心地</H4>
                        </FlexWrapper>
                        <div className='spacer-25' />
                        <Text>手触り、履き心地から伝わる最上の特別感をお約束します。</Text>

                        <div className='spacer-25' />
                        
                        <FlexWrapper style={{flexDirection: 'row'}}>
                            <Circle>03</Circle>
                            <H4>フィット感</H4>
                        </FlexWrapper>
                        <div className='spacer-25' />
                        <Text>アスリートたちのいろんな体型を研究し作りました。</Text>
                    </FlexHalf>
                    <FlexHalf>
                        <img src={Underwear1} alt={'rzeus'} style={{width: '100%', maxHeight: '500px', objectFit: 'contain' }}/>
                    </FlexHalf>
                </FlexWrapper>
                
                <div className='spacer-25' />

                <H3>
                    <span style={{fontSize: '1rem'}}>リオオリンピック銀メダリスト/総合格闘家</span>
                    &nbsp;太田忍&nbsp;
                    <span style={{fontSize: '1rem'}}>によるプロデュース</span>
                </H3>
                <div className='spacer-25' />
                <RizinImage src={Rizin} alt={'rizin'}/>
                <div className='spacer-50' />
                <H3>ラインナップ</H3>
                <div className='spacer-25' />
                <H4>ノーマルタイプ</H4>
                <div className='spacer-25' />
                <ProductImageWrapper>
                    <ProductImage>                
                        <img src={PantsNormal1} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsNormal2} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsNormal3} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsNormal4} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsNormal5} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                </ProductImageWrapper>
                <div className='spacer-50' />
                <H4>ショートタイプ</H4>
                <div className='spacer-25' />
                <ProductImageWrapper>
                    <ProductImage>                
                        <img src={PantsShort1} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsShort2} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsShort3} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsShort4} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={PantsShort5} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                </ProductImageWrapper>
            </Section>

            <div className='spacer-100' />

            <H2>Mask</H2>
            <Section>
                <div className='spacer-50' />
                <FlexWrapper style={{alignItems: 'flex-start'}}>
                    <FlexHalf>
                        <H3 style={{width: 'auto'}}>抗ウィルス生地の<Br/>高機能スポーツマスク</H3>
                        <div className='spacer-25' />
                        <Text>アスリートが提案し、かっこよさを追求したマスクをご用意しました。日本製で抗ウィルス生地によりウィルス感染力を９９％低減する機能性マスクです。健康に、ファッションとして、またギフトとしてもご利用ください</Text>
                    </FlexHalf>
                    <FlexHalf>
                        <img src={Athletes2} alt={'rzeus'} style={{width: '100%', maxHeight: '400px', objectFit: 'contain' }}/>
                    </FlexHalf>
                </FlexWrapper>

                <div className='spacer-50' />

                <FlexWrapper style={{alignItems: 'flex-start'}}>
                    <FlexHalf>
                        <H3>微弱な光でもウィルスを分解</H3>
                        <div className='spacer-25' />
                        <Text>特殊な「酸化タングステン」を繊維素材へ耐久固着させることで太陽光や蛍光灯、LEDなど室内の光でもウィルスを高速分解します。</Text>
                    </FlexHalf>
                    <FlexHalf>
                        <img src={AntiVirus1} alt={'rzeus'} style={{width: '100%', maxHeight: '400px', objectFit: 'contain' }}/>
                    </FlexHalf>
                </FlexWrapper>
                
                <div className='spacer-50' />

                <FlexWrapper style={{alignItems: 'flex-start'}}>
                    <FlexHalf>
                        <H3>優れた抗ウィルス性</H3>
                        <div className='spacer-25' />
                        <Text>生地に接触したウィルスは、感染力が弱まるため、接触後の拡散を抑えます。</Text>
                    </FlexHalf>
                    <FlexHalf>
                        <img src={AntiVirus2} alt={'rzeus'} style={{width: '100%', maxHeight: '400px', objectFit: 'contain' }}/>
                    </FlexHalf>
                </FlexWrapper>

                <div className='spacer-50' />

                <H3>ラインナップ</H3>
                <div className='spacer-25' />
                <ProductImageWrapper>
                    <ProductImage>                
                        <img src={Mask1} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={Mask2} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={Mask3} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={Mask4} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                    <ProductImage>                
                        <img src={Mask5} alt={'rzeus'} width='100%'/>
                    </ProductImage>
                </ProductImageWrapper>
            </Section>

            <div className='spacer-100' />

            <H2>Project Athlete</H2>
            <Section>
                <div className='spacer-50' />
                <FlexWrapper>
                    <FlexHalf>
                        <img src={ProjectAthlete} alt={'rzeus'} width={'100%'}/>
                    </FlexHalf>
                    <FlexHalf>
                        <h4>リオオリンピック銀メダリスト/総合格闘家</h4>
                        <H4>太田忍選手</H4>
                        <div className='spacer-25' />
                        <Text>僕自身パンツで今日の1日の気分が大きく変わります。気合入れたい日はパンツから選び、その日のコンデションを保ってきた大切なものでした。僕自身アスリートですが、やはり自分がモチベーション上げてくれたパンツを商品化できたことは本当に嬉しく思っております。1人でも多くの方が、この状況の中でも、パンツを履くことにより一歩踏み出す勇気なる商品になれば嬉しいです。</Text>
                    </FlexHalf>
                </FlexWrapper>
            </Section>

            <div className='spacer-100' />

            <H2>PreOrder</H2>

            <div className='spacer-100' />

            <H4 style={{textAlign: 'center'}}>RZEUS予約注文フォーム</H4>

            <div className='spacer-50' />


            <FormSection id='form'>
                <p>* は必須項目です</p>

                <div className='spacer-50' />

                <FormLabel>商品タイプを選択してください</FormLabel>
                <div className='spacer-25' />
                <SelectBox 
                    label={'商品タイプ'}　required={true} select={setProductType} value={productType} options={productTypeList} 
                />

                <div className='spacer-25' />

                <FormControl component="fieldset">
                    {productType !== '' && (
                        <FormLabel component="legend">カラーを選択してください</FormLabel>
                    )}
                    <RadioGroup name="gender1" value={product} onChange={handleChangeProduct}>
                    {productType === 'pants-normal' && (
                        <>
                            <FormControlLabel value="0" control={<Radio color="primary" />} label={<ItemImage><img src={PantsNormal1} alt={productList[0].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="1" control={<Radio color="primary" />} label={<ItemImage><img src={PantsNormal2} alt={productList[1].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="2" control={<Radio color="primary" />} label={<ItemImage><img src={PantsNormal3} alt={productList[2].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="3" control={<Radio color="primary" />} label={<ItemImage><img src={PantsNormal4} alt={productList[3].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="4" control={<Radio color="primary" />} label={<ItemImage><img src={PantsNormal5} alt={productList[4].name} width={'100%'} /></ItemImage>} />
                        </>
                    )}
                    {productType === 'pants-short' && (
                        <>
                            <FormControlLabel value="5"control={<Radio color="primary" />} label={<ItemImage><img src={PantsShort1} alt={productList[5].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="6" control={<Radio color="primary" />} label={<ItemImage><img src={PantsShort2} alt={productList[6].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="7" control={<Radio color="primary" />} label={<ItemImage><img src={PantsShort3} alt={productList[7].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="8" control={<Radio color="primary" />} label={<ItemImage><img src={PantsShort4} alt={productList[8].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="9" control={<Radio color="primary" />} label={<ItemImage><img src={PantsShort5} alt={productList[9].name} width={'100%'} /></ItemImage>} />
                        </>
                    )}
                    {productType === 'mask' && (
                        <>
                            <FormControlLabel value="10" control={<Radio color="primary" />} label={<ItemImage><img src={Mask1} alt={productList[10].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="11" control={<Radio color="primary" />} label={<ItemImage><img src={Mask2} alt={productList[11].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="12" control={<Radio color="primary" />} label={<ItemImage><img src={Mask3} alt={productList[12].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="13" control={<Radio color="primary" />} label={<ItemImage><img src={Mask4} alt={productList[13].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="14" control={<Radio color="primary" />} label={<ItemImage><img src={Mask5} alt={productList[14].name} width={'100%'} /></ItemImage>} />
                        </>
                    )}
                    {productType === 'set-normal' && (
                        <>
                            <FormControlLabel value="15" control={<Radio color="primary" />} label={<ItemImage><img src={SetNormal1} alt={productList[15].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="16" control={<Radio color="primary" />} label={<ItemImage><img src={SetNormal2} alt={productList[16].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="17" control={<Radio color="primary" />} label={<ItemImage><img src={SetNormal3} alt={productList[17].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="18" control={<Radio color="primary" />} label={<ItemImage><img src={SetNormal4} alt={productList[18].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="19" control={<Radio color="primary" />} label={<ItemImage><img src={SetNormal5} alt={productList[19].name} width={'100%'} /></ItemImage>} />
                        </>
                    )}
                    {productType === 'set-short' && (
                        <>
                            <FormControlLabel value="20" control={<Radio color="primary" />} label={<ItemImage><img src={SetShort1} alt={productList[20].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="21" control={<Radio color="primary" />} label={<ItemImage><img src={SetShort2} alt={productList[21].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="22" control={<Radio color="primary" />} label={<ItemImage><img src={SetShort3} alt={productList[22].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="23" control={<Radio color="primary" />} label={<ItemImage><img src={SetShort4} alt={productList[23].name} width={'100%'} /></ItemImage>} />
                            <FormControlLabel value="24" control={<Radio color="primary" />} label={<ItemImage><img src={SetShort5} alt={productList[24].name} width={'100%'} /></ItemImage>} />
                        </>
                    )}
                    </RadioGroup>
                </FormControl>

                <div className='spacer-25' />

                {productType === 'pants-normal' || productType === 'pants-short' || productType === 'set-normal' || productType === 'set-short' ? (
                    <FormControl component="fieldset" required={true}>
                        <FormLabel component="legend">パンツのサイズを選択してください</FormLabel>
                        <RadioGroup name="gender1" value={size} onChange={handleChangeSize}>
                            <FlexWrapper style={{flexDirection: 'row'}}>
                                <FormControlLabel value="M" control={<Radio color="primary" />} label="M" />
                                <FormControlLabel value="L" control={<Radio color="primary" />} label="L" />
                                <FormControlLabel value="XL" control={<Radio color="primary" />} label="XL" />
                            </FlexWrapper>
                        </RadioGroup>
                    </FormControl>
                ):""}

                <div className='spacer-25' />

                <FormLabel>個数を選択してください</FormLabel>
                <div className='spacer-25' />
                <SelectBox 
                    label={'個数'}　required={true} select={setQuantity} value={quantity} options={quantityList} 
                />

                <div className='spacer-25' />

                <div style={{textAlign: 'center'}}>合計　{amount + 600}円<br/>&nbsp;&nbsp;（商品価格{amount}円＋送料600円）</div>

                <div className='spacer-50' />

                <FormLabel>次の項目をご記入ください</FormLabel>
                <div className='spacer-25' />
                <TextField 
                    label={'お名前'} type={'text'} required={true} variant='filled'
                    style={{width: '220px', marginBottom: '10px'}}
                    value={name} onChange={e=>setName(e.target.value)}
                />
                <TextField 
                    label={'メールアドレス'} type={'email'} required={true} fullWidth={true} variant='filled'
                    style={{marginBottom: '10px'}}
                    value={email} onChange={e=>setEmail(e.target.value)}
                />
                <TextField 
                    label={'電話番号'} type={'tel'} required={true} variant='filled'
                    style={{width: '220px', marginBottom: '10px'}}
                    value={tel} onChange={e=>setTel(e.target.value)}
                /><br/>
                <TextField 
                    label={'郵便番号'} fullWidth={false} multiline={false} rows={1} required={true} type={'text'}
                    value={postalCode} name="postCode" variant='filled'
                    onChange={e=>setPostalCode(e.target.value)} style={{width: '220px', marginBottom: '10px'}}
                    onKeyUp={complementAddress} onBlur={onBlurZipcode}
                /><br/>
                <TextField 
                    label={'都道府県'} fullWidth={false} multiline={false} rows={1} required={true} type={'text'}
                    name="address1" id="address1" variant='filled' 
                    value={prefecture} onChange={e=>setPrefecture(e.target.value)}
                    style={{width: '220px', marginRight: '40px', marginBottom: '10px'}}
                />
                <Br />
                <TextField 
                    label={'市区町村'} fullWidth={false} multiline={false} rows={1} required={true} type={'text'}
                    name="address2" id="address2" variant='filled' style={{width: '220px', marginBottom: '10px'}}
                    value={city} onChange={e=>setCity(e.target.value)}
                />
                <TextField 
                    label={'番地以降'} fullWidth={true} multiline={false} rows={1} required={true} type={'text'}
                    name="address3" id="address3" variant='filled' style={{marginBottom: '10px'}}
                    value={street} onChange={e=>setStreet(e.target.value)}
                />
                
                <div className='spacer-25' />
                <div style={{textAlign: 'center'}}>
                    <PrimaryButton label={'送信する'} operation={()=>saveOrder(productType, productList[product] ? productList[product].name : '', size, quantity, amount, name, email, tel, postalCode, prefecture, city, street)} />
                    <div className='spacer-50' />
                </div>
            </FormSection>
            {/* トップに戻るボタン */}
            <div style={{width: '300px', margin: '50px auto', cursor: 'pointer'}} onClick={() => dispatch(push('/'))}>
                <img src={BackToTop} alt={'backtotop'} width={'100%'} />
            </div>
            {/* 予約フォームへ移動するボタン */}
            <PreOrderButton>
                <AnchorLink href="#form" offset='250'>
                    <img src={PreOrder} alt={'preorder'} width={'100%'} />
                </AnchorLink>
            </PreOrderButton>
            <div className='spacer-100' />
        </Layout>
    )
}
export default Rzeus

const PreOrderButton = styled.div`
    width: 200px;
    cursor: pointer;
    position: fixed;
    right: 30px;
    bottom: 30px;
    @media screen and (max-width:768px){
        width: 150px;
        right: 10px;
        bottom: 10px;
    }
`

const Section = styled.section`
    width: 1120px;
    margin: 0 auto;
    @media screen and (max-width:1120px){
        width: 100%;
        padding: 0 20px;
    }
`
const Br = styled.br`
    display: none;
    @media screen and (max-width:1120px){
        display: block;
    }
`
const H1 = styled.h1`
    font-size: 3.5rem;
    text-align: left;
    display: inline-block;
    font-weight: bold;
    @media screen and (max-width:1120px){
        font-size: 2rem;
    }
`
const H2 = styled.h2`
    font-size: 4rem;
    color: #fff;
    text-align: center;
    position: relative;
    &:before {
        position: absolute;
        top: -3px;
        left: calc(55% - 400px);
        width: 400px;
        height: 10px;
        content: '';
        background: #fff;
    }
    &:after {
        position: absolute;
        bottom: -10px;
        right: 0;
        width: 55%;
        height: 1px;
        content: '';
        background: #fff;
    }
    @media screen and (max-width:768px){
        font-size: 3rem;
    }
`
const H3 = styled.h3`
    position: relative;
    background-color: #fff;
    color: #000;
    width: auto;
    height: auto;
    padding: 10px;
    border-radius: 22.5px;
    @media screen and (max-width:1120px){
        font-size: 1.1rem;
    }
`
const H4 = styled.h4`
    font-size: 1.5rem;
    @media screen and (max-width:1120px){
        text-align: center;
        font-size: 1.25rem;
    }
`
const Text = styled.p`
    line-height: 1.8rem;
    letter-spacing: .05rem;
`
const RizinImage = styled.img`
    width: 1120px;
    @media screen and (max-width:1120px){
        width: 100%;
        padding: 0 20px;
    }
`
const Circle = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    color: #000;
    width: 70px;
    height: 70px;
    font-size: 1.75rem;
    font-weight: bold;
    border-radius: 50%;
    margin-right: 10px;
    position: relative;
    &:after {
        content: '';
        display: block;
        position: absolute;
        left: 35px;
        bottom: 10px;
        height: 1px;
        width: 500px;
        background-color: #fff;
    }
    @media screen and (max-width:1120px){
        &:after {
            display: none;
        }
    }
`
const Hero = styled.section`
    content: "";
    width: 100%;
    height: 70vw;
    background-image: url(${HeroImage});
    background-size:100% auto;
    background-position: top center;
    background-repeat: no-repeat;
`
const FlexWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    @media screen and (max-width:1120px){
        flex-direction: column;
    }
`
const FlexHalf = styled.div`
    width: 50%;
    padding: 20px;
    @media screen and (max-width:1120px){
        width: 100%;
    }
`
const ProductImageWrapper = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    @media screen and (max-width:1120px){
        flex-direction: column;
        align-items: center;
    }
`
const ProductImage = styled.div`
    width: 20%;
    padding: 20px;
    @media screen and (max-width:1120px){
        width: 100%;
        max-width: 320px;
    }
`
const FormSection = styled.section`
    width: 480px;
    margin: 0 auto;
    @media screen and (max-width:1120px){
        width: 320px;
        /* padding: 0 20px; */
    }
`
const ItemImage = styled.div`
    display: flex;
    align-items: center;
    width: 160px;
    max-height: 160px;
    object-fit: contain;
    margin: 20px 0;
`
const Bracket = styled.span`
    @media screen and (max-width:1120px){
        display: none;
    }
`